import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  FaHome, 
  FaBuilding, 
  FaCalendarAlt, 
  FaUsers, 
  FaUser,
  FaClipboardList,
  FaUserCheck,
  FaSignOutAlt,
  FaUserCircle
} from 'react-icons/fa';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('¿Estás seguro de cerrar sesión?')) {
      logout();
      navigate('/login');
    }
  };

  const menuItems = [
    { path: '/', icon: <FaHome />, label: 'Inicio' },
    { path: '/cooperativas', icon: <FaBuilding />, label: 'Cooperativas' },
    { path: '/eventos', icon: <FaCalendarAlt />, label: 'Eventos' },
    { path: '/personas', icon: <FaUsers />, label: 'Personas' },
    { path: '/usuarios', icon: <FaUser />, label: 'Usuarios' },
    { path: '/inscripciones', icon: <FaClipboardList />, label: 'Inscripciones' },
    { path: '/asistencia', icon: <FaUserCheck />, label: 'Asistencia' },
  ];

  return (
    <div className="layout">
      <header className="header">
        <div className="header-container">
          <div className="header-logo">
            <h1>FEDECOVERA</h1>
            <p>Sistema de Inscripción a Eventos</p>
          </div>
          {user && (
            <div className="header-user">
              <div className="user-info">
                <FaUserCircle className="user-icon" />
                <div className="user-details">
                  <span className="user-name">{user.nombre_completo || user.username}</span>
                  <span className="user-rol">{user.rol}</span>
                </div>
              </div>
              <button className="btn-logout" onClick={handleLogout} title="Cerrar sesión">
                <FaSignOutAlt />
                <span>Salir</span>
              </button>
            </div>
          )}
        </div>
      </header>

      <nav className="navbar">
        <div className="navbar-container">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </div>
      </nav>

      <main className="main-content">
        <div className="container">
          {children}
        </div>
      </main>

      <footer className="footer">
        <div className="footer-container">
          <p>© {new Date().getFullYear()} FEDECOVERA. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
